// Karta z naglowkiem, opisem i pasem akcji (Wstecz / Dalej / Pomin) dla kroku Setup Wizardu.

import React, { FC, ReactNode } from 'react';
import { Button, Paper, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

import styles from 'theme/components/wise/WiseSetupCard/WiseSetupCard.module.scss';

interface IWiseSetupCardProps {
  title: string;
  description?: string;
  children: ReactNode;
  onNext: () => void;
  onPrev?: () => void;
  onSkip?: () => void;
  nextDisabled?: boolean;
  nextLoading?: boolean;
  isLastStep?: boolean;
  className?: string;
}

const WiseSetupCard: FC<IWiseSetupCardProps> = ({
  title,
  description,
  children,
  onNext,
  onPrev,
  onSkip,
  nextDisabled = false,
  nextLoading = false,
  isLastStep = false,
  className
}) => {
  const { t } = useTranslation();

  return (
    <Paper className={classnames(styles.componentWrapper, className)} elevation={1}>
      <div className={styles.header}>
        <h2 className={styles.title}>{title}</h2>
        {description ? <p className={styles.description}>{description}</p> : null}
      </div>
      <div className={styles.content}>{children}</div>
      <div className={styles.footer}>
        <div className={styles.footerLeft}>
          {onPrev ? (
            <Button variant="outlined" onClick={onPrev}>
              {t('panelSetup.actions.prev')}
            </Button>
          ) : null}
        </div>
        <div className={styles.footerRight}>
          {onSkip ? (
            <Button variant="text" onClick={onSkip}>
              {t('panelSetup.actions.skip')}
            </Button>
          ) : null}
          <Button
            variant="contained"
            onClick={onNext}
            disabled={nextDisabled || nextLoading}
            startIcon={nextLoading ? <CircularProgress size={16} /> : undefined}>
            {isLastStep ? t('panelSetup.actions.finish') : t('panelSetup.actions.next')}
          </Button>
        </div>
      </div>
    </Paper>
  );
};

export default WiseSetupCard;
